import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { queryClient } from 'providers';

import { AssignClientsQueryKeys } from './query-keys';
const { UpdateAssign } = AssignedClientsApiService();

export const useUpdateAssign = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return UpdateAssign(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: AssignClientsQueryKeys.all,
        });
        if (data?.rs == 0) {
          message.error(data?.rm);
        } else {
          message.success(data?.rm);
        }
      },
    },
  );
};
